<template>
    <div>
        <slot></slot>
        <template v-if="$slots.extra">
            <a class="read-more-link" href="#" v-show="!show" @click.prevent="handleClick">lire +</a>
            <b-collapse id="read-more" v-model="show">
                <slot name="extra"></slot>
            </b-collapse>
        </template>
    </div>
</template>

<script>
    import { VBToggle, BCollapse } from 'bootstrap-vue';

    export default {
        props: {
            id: String
        },
        components: {
            BCollapse
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            handleClick() {
                if(!this.show) {
                    this.show = true;
                }
            }
        },
        directives: {
            VBToggle
        }
    }
</script>